import { render } from "./TabSummary.vue?vue&type=template&id=8bee7d6a&scoped=true"
import script from "./TabSummary.vue?vue&type=script&lang=js"
export * from "./TabSummary.vue?vue&type=script&lang=js"

import "./TabSummary.vue?vue&type=style&index=0&id=8bee7d6a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bee7d6a"]])

export default __exports__